import { useMemo, useState } from "react";
import client from "libs/client";
import type { ProgramGameSelectOption } from "../programGameModal";

export function useDiscoverGamesProgramGameModal() {
	const [isOpen, setIsOpen] = useState(false);
	const { data: ownershipsResponse } = client.loadOwnerships.useQuery({});

	const ownershipOptions = useMemo<ProgramGameSelectOption[]>(() => {
		const raw = ownershipsResponse?.data?.data;
		if (raw === undefined || Array.isArray(raw) === false) {
			return [];
		}
		return raw.map((item) => ({
			value: String(item.value),
			label: item.label ?? "",
		}));
	}, [ownershipsResponse]);

	return {
		isOpen,
		open: () => setIsOpen(true),
		close: () => setIsOpen(false),
		ownershipOptions,
	};
}
